import FlumpObject from "../../general/objects/FlumpObject";
import { audioPlayer } from "../../PhaserExtension";

export default class ChoiceIcon extends FlumpObject
{
    constructor(game, config, library, id)
    {
        super(game, config, library);

        this.id = id;

        this.btn = new Phaser.Button(this.game, 0, 0, "storyImage" + id);
        this.btn.onInputUp.add(this.onClicked, this);
        this.btn.anchor.setTo(0.5);
        this.addChild(this.btn);

        this.burst = new FlumpObject(this.game, this.config.burst, library);
        this.burst.anchor.setTo(0.5);
        this.addChild(this.burst);

        this.position.setTo(config.position.x, config.position.y);

        this.onSelected = new Phaser.Signal();
        this.visible = false;

        this.btn.inputEnabled = false;
        this.btn.events.onInputOver.add(this.onOver, this);
        this.btn.events.onInputOut.add(this.onOut, this);
        this.btn.events.onInputUp.add(this.onUp, this);
        this.btn.events.onInputDown.add(this.onDown, this);
    }

    update()
    {
        super.update();
        this.burst.update();
    }

    onOver()
    {
        this.scale.setTo(1.05);
    }

    onOut()
    {
        if(this.display.paused)
        {
            this.scale.setTo(1.05);
        }
        else
        {
            this.scale.setTo(1);
        }
    }

    onDown()
    {
        this.scale.setTo(0.9);
    }

    onUp()
    {
        if(this.scale.x < 1)
        {
            this.scale.setTo(1.05);
        }
    }

    reveal()
    {
        this.btn.visible = false;

        this.loop(this.keys.idle);
        this.playOnce(this.keys.enter, true);
        this.onComplete.addOnce(this.onEnterComplete, this);

        this.burst.playOnce(this.burst.keys.idle, true, true);
        this.burst.onComplete.addOnce(this.onBurstComplete, this);

        audioPlayer.play(this.game, this.config.sound);

        this.visible = true;
    }

    onEnterComplete()
    {
        this.btn.visible = true;
    }

    onBurstComplete()
    {
        this.burst.visible = false;
    }

    onClicked()
    {
        this.onSelected.dispatch(this.id);
    }

    playSelected()
    {
        this.bringToTop();
        this.display.paused = true;
    }

    enable()
    {
        this.btn.inputEnabled = true;
    }

    disable()
    {
        this.onSelected.removeAll();
        this.btn.events.onInputDown.remove(this.onDown, this);
        this.btn.events.onInputOver.remove(this.onOver, this);
    }

    destroy(children)
    {
        this.onSelected.dispose();
        super.destroy(true);
    }
}
